import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {AudioRecordDataService} from './audioRecordData.service';
import {AudioRecordModel} from '../../../api/model/audioRecord.model';
import {AudioRecordConverter} from '../../../api/model/converter/audioRecord.converter';


@Injectable({providedIn: 'root'})
export class AudioRecordDataServiceAdapter extends
    AbstractDataServiceDtoAdapter<AudioRecordModel, AudioRecordConverter> {
    constructor(dataService: AudioRecordDataService, converter: AudioRecordConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): AudioRecordModel {
        return new AudioRecordModel();
    }
}
